import { AxiosError } from 'axios';
import { AppExceptionResponseData } from '../../../hooks/useHandleAppException';
import LangEnum from '../../../lang/LangEnum';
import { getBrandLoginContext } from '../../../services/modules/sso/sso.repository';

const HANDOFF_HASH_PARAM = 'hc';

export const extractHandoffCode = (hash: string): string | null => {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  return params.get(HANDOFF_HASH_PARAM) || null;
};

export const buildLocalException = (code: LangEnum): AppExceptionResponseData => ({
  code,
  message: '',
});

export const readAppExceptionData = (error: unknown): AppExceptionResponseData | null => {
  const exceptionData = (error as AxiosError<AppExceptionResponseData>)?.response?.data;
  return exceptionData?.code ? exceptionData : null;
};

export const resolveLoginBrandId = async (brandSlug: string): Promise<string | undefined> => {
  try {
    const response = await getBrandLoginContext(brandSlug);
    return response.ok ? response.data?.id : undefined;
  } catch {
    return undefined;
  }
};
